import React, { Component } from 'react'

import { get } from '@js/common/api'

import CTA from '@f/elements/CTA'

export class VendorHeadquarters extends Component {
  state = {
    display_hq_phone: false
  }

  togglePhone = () => {
    this.setState(prevState => {
      return {
        display_hq_phone: !prevState.display_hq_phone
      }
    })
  }

  componentDidMount() {
    get(`sales-partners/?nid=${this.props.vendorNid}`).then(data => {
      this.setState({
        headquarters: data[0]
      })
    })
  }

  render() {
    let headquarters_phone

    if (!this.state.headquarters?.contact_phone) {
      headquarters_phone = null
    } else if (this.state.headquarters && this.state.display_hq_phone) {
      headquarters_phone = <span>{this.state.headquarters.contact_phone}</span>
    } else {
      headquarters_phone = (
        <CTA
          type='text-primary'
          tag='button'
          className='[ f-t-body ]'
          onClick={this.togglePhone}>
          Telefonnummer anzeigen
        </CTA>
      )
    }

    return this.state.headquarters ? (
      <div className='[ f-t-body f-c-fo-pri ]'>
        <b>{this.props.vendorName}</b>
        <br />
        {this.state.headquarters.address_line_1
          ? this.state.headquarters.address_line_1
          : null}
        <br />
        {this.state.headquarters.address_line_2 ? (
          <>
            {this.state.headquarters.address_line_2}
            <br />
          </>
        ) : null}
        {this.state.headquarters.postal_code
          ? this.state.headquarters.postal_code +
            ' ' +
            this.state.headquarters.city
          : null}
        <br />
        {headquarters_phone ? this.state.headquarters.contact_phone : null}
      </div>
    ) : (
      <div className='[ f-t-body f-c-fo-pri ]'>
        <b>{this.props.vendorName}</b>
      </div>
    )
  }
}
